import { nikkeCatalogSearchText } from '../../nikke-catalog/domain/nikkeCatalog.js';

export function resolveRaidControlNikkeAutocompleteQuery(body = '') {
  const match = String(body || '').match(/(?:^|\s)<([^\s<]+)$/);
  return match ? match[1].toLocaleLowerCase('ko-KR') : '';
}

export function buildRaidControlNikkeAutocompleteSuggestions(items = [], query = '') {
  const needle = String(query || '').toLocaleLowerCase('ko-KR');
  if (!needle) return [];
  return (Array.isArray(items) ? items : [])
    .filter((item) => nikkeCatalogSearchText(item).toLocaleLowerCase('ko-KR').includes(needle))
    .slice(0, 6);
}
